import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import LoadingContainer from '../../controls/LoadingContainer'
import { useToast } from '../../controls/Toast/ToastService'
import { CiLocationArrow1 } from "react-icons/ci";
import Empty from '../../controls/Empty'
import Card from '../../controls/Card'
import { MdErrorOutline } from 'react-icons/md'
import * as rechargeHistoryCrud from '../../../configurations/crud/rechargeHistoryCrud'
import Paging from '../../controls/Paging'
import { PAGE_SIZE } from '../../../configurations/initUrls';
import { EBoolBg, GetEBoolName } from '../../../configurations/enums/EBool';
import StatusContainer from '../../controls/StatusContainer';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Input from '../../controls/Input';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import moment from 'moment';
import { ERechargeHistoryStatusBg, GetERechargeHistoryStatusName } from '../../../configurations/enums/ERechargeHstoryStatus';
import useGlobalLoader from '../../../configurations/useGlobalLoader';



export default function GetAllByUser() {
    const initValues = {
        PageNo: 1,
        PageSize: PAGE_SIZE,
        SearchTerm: "",
    }
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [lodingCrud, setLodingCrud] = useState(false)
    const [userData, setUserData] = useState([]);
    const [search, setSearch] = useState(initValues);
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [searchTerm, setSearchTerm] = useState("");
    const [searchDebounce, setSearchDebounce] = useDebounce("", 700);

    useEffect(() => {
        setSearchDebounce(searchTerm)
    }, [searchTerm])

    useEffect(() => {
        onSearch()
    }, [searchDebounce])

    const OnPageChange = (e) => {
        setSearch({ ...search, PageNo: e })
        onSearchNew({
            PageNo: e,
            PageSize: search.PageSize,
            SearchTerm: search.SearchTerm
        })
    }
    const onSearchChange = (e) => {
        setSearchTerm(e.target.value)
    }
    const onSearch = () => {
        onSearchNew({
            PageNo: 1,
            PageSize: search.PageSize,
            SearchTerm: searchTerm
        })
    }
    const onSearchNew = (search) => {
        getAllByUserr(search)
    }

    const doRefresh = () => {
        setSearch({ ...search, PageNo: 1 })
        onSearchNew({
            PageNo: 1,
            PageSize: search.PageSize,
            SearchTerm: search.SearchTerm
        })
    }

    const getAllByUserr = (params) => {
        setLoding(true)
        start()
        rechargeHistoryCrud.GetAllByUser(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    return (
        <Container title={"Recharge History"}>
            <div className='w-full'>
                <Card title={"Recharge History"} isUser={true} isBorder={true} isRefresh={true} doRefresh={doRefresh}>
                    <div className='flex flex-col '>
                        <div className='py-3'>
                            <Input Icon={<FontAwesomeIcon color='gray' icon={faSearch} />}
                                onChange={onSearchChange}
                                placeholder="Search Recharge History"></Input>
                        </div>
                        <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData} >
                            <div class="overflow-x-auto">
                                {
                                    !loding ?
                                        userData.length > 0 ?
                                            <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                                                <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                                                    <tr>
                                                        <th scope="col" class="px-2 py-3">
                                                            <div class="flex items-center">
                                                                <input id="checkbox-all" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2" />
                                                                <label for="checkbox-all" class="sr-only">checkbox</label>
                                                            </div>
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            #
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Created On
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Count/Price
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Note
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Order No
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Pay No
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Pay Details
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Contact Name
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Contact No
                                                        </th>
                                                        <th scope="col" class="px-2 py-3">
                                                            Status
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {userData.map((item, index) =>
                                                        <tr class="bg-white border-b hover:bg-gray-100">
                                                            <td class="w-4 px-2 py-2">
                                                                <div class="flex items-center">
                                                                    <input id="checkbox-table-search-1" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2" />
                                                                    <label for="checkbox-table-search-1" class="sr-only">checkbox</label>
                                                                </div>
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {item.id}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {moment(item.createdOn).format('DD/MM/YYYY hh:mm A')}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {item.opdCount} at ₹ {item.amount.toFixed(2)}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {item.note}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {item.paymentOrderNo}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {item.paymentNo}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {item.paymentDetails}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {item.rechargeContactName}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                {item.rechargeContactNo}
                                                            </td>
                                                            <td class="px-2 py-2 text-nowrap">
                                                                <StatusContainer
                                                                    bg={ERechargeHistoryStatusBg(item.status)}
                                                                    text={GetERechargeHistoryStatusName(item.status)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}

                                                </tbody>
                                            </table>
                                            : <Empty>
                                                No Items Found.
                                            </Empty>
                                        : <LoadingContainer />
                                }
                            </div>
                        </Paging>
                    </div>
                </Card>
            </div>
        </Container>
    )
}